export const constant = {
	selector: {
		target: 'js-sortable',
		rows: 'js-sortable-row',
		handler: 'data-update-handler',
		rowId: 'data-row-id',
		order: 'data-row-order',
	},
}
